import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../globals';
import { Message } from 'primeng/primeng';
import { IServiceAssignment } from '../../../Models/IServiceAssignment';
import { IServiceLog } from '../../../Models/IServiceLog';
import { IService } from '../../../Models/IService';
import { ServicesService } from '../../../Services/ServicesService';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { Observable, throwError, of } from "rxjs";
import { String } from 'core-js';
import { min } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'IEPServiceLogByProvider',
  templateUrl: './IEPServiceLogByProvider.component.html',
  styleUrls: ['./IEPServiceLogByProvider.component.css']
})

export class IEPServiceLogByProviderComponent implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  messages: Message[];
  _servicesService: ServicesService;
  _lookupService: LookupService;
  serviceAssignments: IServiceAssignment[];
  serviceLogs: IServiceLog[];
  services: IService[];
  serviceAssignment: any = [];
  serviceLog: any = [];
  service: any = [];
  lookupServiceName: ILookupBase[];
  lookupCurrentService: ILookupBase[];
  lookupProvider: ILookupBase[];
  lookupSites: ILookupBase[];
  lookupDuration: ILookupBase[];
  lookupFrequency: ILookupBase[];
  lookupIndividualGroup: ILookupBase[];
  lookupLocation: ILookupBase[];
  lookupAbsenceCode: ILookupBase[];
  lookupSessionStatus: ILookupBase[];
  serviceAssignmentId: number;
  serviceId: string;
  servicesList: boolean;
  serviceEdit: boolean;
  logList: boolean;
  logEdit: boolean;
  canEdit: boolean;
  serviceDocument: string;
  serviceName: string;
  providerName: string;
  starSpecialEducationServiceId: string;
  providerId: string;
  duration: string;
  frequency: string;
  startDate: Date;
  endDate: Date;
  currentDate: Date;
  minimumStartDate: Date;
  minDateOfService: Date;
  maxDateOfService: Date;
  individualGroup: string;
  location: string;
  absenceCode: string;
  fromTime: Date;
  toTime: Date;
  minutes: number;
  showSpinner: boolean = false;
  validation: boolean;

  constructor
    (
      globals: Globals,
      servicesService: ServicesService,
      lookupService: LookupService,
      @Inject('BASE_URL') baseUrl: string) {
    this._servicesService = servicesService;
    this._lookupService = lookupService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
  }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.servicesList = true;
    if (this._myGlobals.selectedStudent.localStudentId != null) {
      this.GetServiceAssignments();
      this.GetCurrentServices();
    }
  }

  GetServiceAssignments(): void {
    this.showSpinner = true;
    this._servicesService.getServiceAssignmentsForStudent(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IServiceAssignment[]) => {
      this.serviceAssignments = res;
      this.showSpinner = false;
    },
      err => {
        this.errorHandler(err);
        this.showSpinner = false;
      }
    );
  }

  GetCurrentServices() {
    this._servicesService.getCurrentServices(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IService[]) => {
      this.services = res;
    },
      err => this.errorHandler(err)
    );
  }

  selectedService(serviceId, serviceDocument): void {
    this.GetServiceAssignment(serviceId)
    this.servicesList = true;
    this.logList = false;
    this.logEdit = false;
    this.clearMessages();
    this.serviceDocument = serviceDocument;
    //if (serviceDocument.includes('Current')) {
    //  this.canEdit = true;
    //}
    //else {
    //  this.canEdit = false;
    //}
  }

  GetServiceAssignment(serviceId) {
    this._servicesService.getServiceAssignment(serviceId).subscribe((res: IServiceAssignment) => {
      this.serviceAssignment = res;
      this.serviceId = this.serviceAssignment.serviceId.toString();
      this.starSpecialEducationServiceId = this.serviceAssignment.starSpecialEducationServiceId.toString();
      this.providerId = this.serviceAssignment.providerId.toString();
      this.duration = this.serviceAssignment.duration.toString();
      this.frequency = this.serviceAssignment.frequency.toString();
      this.individualGroup = this.serviceAssignment.individualGroup.toString();
      this.location = this.serviceAssignment.location.toString();
      this.canEdit = this.serviceAssignment.canEditServiceLogRecord;
      this.serviceAssignment.startDate = this.serviceAssignment.startDate == null ? null : new Date(this.serviceAssignment.startDate);
      this.serviceAssignment.endDate = this.serviceAssignment.endDate == null ? null : new Date(this.serviceAssignment.endDate);

      this.service = this.services.find(x => {
        return x.id === this.serviceAssignment.serviceId
      })
      if (this.service != null) {
        let oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        this.minimumStartDate = oneYearAgo;
      }
      this.LoadLookupServices();
      this.serviceEdit = true;
    },
      err => this.errorHandler(err)
    );
  }

  addServiceAssignment(): void {
    this.clearMessages();
    this.canEdit = true;
    this.serviceAssignment = {} as IServiceAssignment;
    this.serviceAssignment.id = 0;
    this.serviceAssignment.localStaffId = null;
    this.serviceAssignment.startDate = new Date(Date());
    this.serviceAssignment.duration = null;
    this.serviceAssignment.frequency = null;
    this.serviceAssignment.individualGroup = null;
    this.serviceAssignment.location = null;
    this.serviceAssignment.starSpecialEducationServiceId = null;
    this.serviceAssignment.providerId = null;
    this.serviceAssignment.endDate = null;

    this.serviceDocument = null;
    this.serviceId = null;
    this.starSpecialEducationServiceId = null;
    this.providerId = null;
    this.duration = null;
    this.frequency = null;
    this.individualGroup = null;
    this.location = null;
    this.lookupProvider = null;

    this.LoadLookupServices();

    this.servicesList = true;
    this.serviceEdit = true;
    this.logList = false;
    this.logEdit = false;

    this.scrollToBottom();
  }

  saveServiceAssignment() {
    this.clearMessages();
    if (this.validateServiceAssignmentForm()) {
      this.serviceAssignment.starSpecialEducationServiceId = parseInt(this.starSpecialEducationServiceId);
      this.serviceAssignment.providerId = parseInt(this.providerId);
      this.serviceAssignment.siteId = this._myGlobals.selectedStudent.siteId;
      this.serviceAssignment.duration = parseInt(this.duration);
      this.serviceAssignment.frequency = parseInt(this.frequency)
      this.serviceAssignment.individualGroup = parseInt(this.individualGroup)
      this.serviceAssignment.location = parseInt(this.location)
      if (this.serviceAssignment.id === 0) {
        this.serviceAssignment.serviceId = this.service.id.toString();
      }
      this._servicesService.insertUpdateServiceAssignment(this.serviceAssignment).subscribe((res: IServiceAssignment) => {
        let successMessage: Message = {
          severity: 'success', summary: 'Record Saved Successfully',
          detail: res.id.toString() + " " + res.serviceName
        }
        this.addMessage(successMessage);
        this.serviceEdit = false;
        this.GetServiceAssignments();
      },
        err => this.errorHandler(err)
      );
    }
  }

  viewLogList(serviceId, serviceDocument,
    serviceName, providerName, startDate, endDate, canEditServiceLogRecord): void {
    this.GetServiceLogs(serviceId);
    this.serviceAssignmentId = serviceId;
    this.servicesList = true;
    this.serviceEdit = false;
    this.logList = true;
    this.logEdit = false;
    this.clearMessages();

    this.serviceDocument = serviceDocument;
    this.serviceName = serviceName;
    this.providerName = providerName;
    this.startDate = startDate;
    this.endDate = endDate;
    this.canEdit = canEditServiceLogRecord;

    this.scrollToBottom();
  }

  GetServiceLogs(serviceId) {
    this._servicesService.getServiceLogs(serviceId).subscribe((res: IServiceLog[]) => {
      this.serviceLogs = res;
    },
      err => console.error(err)
    );
  }

  selectedLog(logId): void {
    this.GetServiceLog(logId)
    this.servicesList = true;
    this.serviceEdit = false;
    this.logList = false;
    //if (this.serviceDocument.includes('Current')) {
    //  this.canEdit = true;
    //}
    //else {
    //  this.canEdit = false;
    //}
  }

  GetServiceLog(logId) {
    this._servicesService.getServiceLog(logId).subscribe((res: IServiceLog) => {
      this.serviceLog = res;
      this.absenceCode = this.serviceLog.absenceCode == null ? null : this.serviceLog.absenceCode.toString();
      this.serviceLog.dateOfService = this.serviceLog.dateOfService == null ? null : new Date(this.serviceLog.dateOfService);

      let curDate = new Date(Date());
      if (this.serviceLog.startTime) {
        this.fromTime = this.convertStringToTime(this.serviceLog.startTime);
      }

      if (this.serviceLog.endTime) {
        this.toTime = this.convertStringToTime(this.serviceLog.endTime);
        let timeDif = this.toTime.getTime() - this.fromTime.getTime();
        this.minutes = timeDif / 1000 / 60;
      }
      else {
        this.toTime = null;
        this.minutes = null;
      }

      this.LoadLookupLog();
      this.logEdit = true;
      // Get Min/Max date and Can Edit
      this.GetLogDateCanEdit();
    },
      err => this.errorHandler(err)
    );
  }

  addServiceLog(): void {
    this.clearMessages();
    this.serviceLog = {} as IServiceLog;
    this.serviceLog.id = 0;
    this.serviceLog.serviceAssignmentId = this.serviceAssignmentId;
    this.serviceLog.dateOfService = null;
    this.serviceLog.startTime = null;
    this.serviceLog.endTime = null;
    this.serviceLog.sessionStatus = "Completed";
    this.serviceLog.isMakeup = null;
    this.serviceLog.note = null;
    this.serviceLog.results = null;
    this.serviceLog.absenceCode = null;

    this.absenceCode = null;
    //Default time
    let curDate = new Date(Date());
    let timeOnly = curDate.getHours() + ":00"
    this.fromTime = new Date(curDate.getFullYear() + " " + timeOnly);
    this.toTime = null;
    this.minutes = null;

    this.LoadLookupLog();
    // Get Min/Max date and Can Edit
    this.GetLogDateCanEdit();

    this.servicesList = true;
    this.serviceEdit = false;
    this.logList = false;
    this.logEdit = true;
  }

  GetLogDateCanEdit() {
    this._servicesService.getServiceAssignment(this.serviceAssignmentId).subscribe((res: IServiceAssignment) => {
      this.serviceAssignment = res;
      this.minDateOfService = this.serviceAssignment.serviceLogRecordStartDate == null ? null : new Date(this.serviceAssignment.serviceLogRecordStartDate);
      this.maxDateOfService = this.serviceAssignment.serviceLogRecordEndDate == null ? null : new Date(this.serviceAssignment.serviceLogRecordEndDate);
      this.canEdit = this.serviceAssignment.canEditServiceLogRecord;
    },
      err => this.errorHandler(err)
    );
  }

  saveServiceLog() {
    this.clearMessages();
    if (this.minutes) {
      //use minutes to calculate endtime on save
      this.toTime = new Date(this.fromTime);
      this.toTime.setMinutes(this.toTime.getMinutes() + this.minutes);
    }

    this.validateForm();
    if (this.validation == true) {
      this.serviceLog.absenceCode = parseInt(this.absenceCode);
      if (this.fromTime != null) {
        this.serviceLog.startTime = this.fromTime.getHours() + ":" + this.fromTime.getMinutes();
      }
      if (this.toTime) {        
        this.serviceLog.endTime = this.toTime.getHours() + ":" + this.toTime.getMinutes();
      }
      this._servicesService.insertUpdateServiceLog(this.serviceLog).subscribe((res: IServiceLog) => {
        let successMessage: Message = {
          severity: 'success', summary: 'Record Saved Successfully',
          detail: res.id.toString()
        }
        //this.addMessage(successMessage);
        //this.logEdit = false;
        this.viewLogList(this.serviceAssignmentId, this.serviceDocument, this.serviceName, this.providerName, this.startDate, this.endDate, this.canEdit);
      },
        err => this.errorHandler(err)
      );
    }
  }

  validateForm() {
    this.validation = true;
    if (this.serviceLog.sessionStatus == null || this.serviceLog.sessionStatus === "") {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Session Status is required'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }

    if (this.serviceLog.sessionStatus == "Completed" && !this.fromTime) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Start Time is required'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.serviceLog.sessionStatus == "Completed" && (!this.minutes || this.minutes < 0 || this.minutes > 900)) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Minutes is required'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.serviceLog.sessionStatus == "Completed" && (!this.minutes || this.minutes < 0 || this.minutes > 900)) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Minutes must be between 0 and 900'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.serviceLog.sessionStatus == "Completed" && this.fromTime.getHours() > this.toTime.getHours()) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Calculated End Time should be greater than Start Time. Please check that the number of minutes would not extend the service past midnight.'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.serviceLog.sessionStatus == "Completed" && this.serviceLog.dateOfService == null) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Date of Service is required'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.serviceLog.sessionStatus == "Cancelled" && this.absenceCode == null) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Absence Code is required'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }

    return this.validation;
  }

  validateServiceAssignmentForm(): boolean {
    this.clearMessages();
    let isValid: boolean = true;

    let providerId: number = parseInt(this.providerId);
    let serviceCode: number = parseInt(this.starSpecialEducationServiceId)
    let currentService = this.services.find(s => s.id.toString() === this.serviceId);
    let conflictingService = this.serviceAssignments.find(sa =>
      currentService &&
      currentService.id === sa.serviceId
      && sa.providerId === providerId
      && sa.siteId === this._myGlobals.selectedStudent.siteId
      && sa.endDate === null)

    if (this.serviceAssignment.id === 0 && conflictingService) {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'There is already an existing service assignment for the selected service and provider'
      };
      this.addMessage(errorMessage);
      isValid = false;
    }

    return isValid;
  }

  SetAbsenceCode(status) {
    if (status.value == "Completed") {
      this.absenceCode= null;
    }

    if (status.value === "Cancelled") {
      //calulate duration
      let minutes: number = 0;
      let serviceAssignment: IServiceAssignment = this.serviceAssignments.find(s => s.id === this.serviceAssignmentId);
      if (serviceAssignment) {
        let durationName = serviceAssignment.durationName
        if (durationName) {
          let spaceIndex = durationName.indexOf(" Minutes")
          let minuteString = durationName.substr(0, spaceIndex);
          minutes = Number(minuteString) || 0
        }
        else {
          minutes = 0;
        }
      }
      else {
        minutes = 0;
      }
      this.toTime = new Date(this.fromTime);
      this.toTime.setMinutes(this.toTime.getMinutes() + minutes);
      this.minutes = minutes;
    }
  }

  onAbsenceCodeChange() {
    let minutes: number = 0;
    if (this.absenceCode === '39' || this.absenceCode === '45') {
      let minutes: number = 0;
    }
    else {
      let serviceAssignment: IServiceAssignment = this.serviceAssignments.find(s => s.id === this.serviceAssignmentId);
      if (serviceAssignment) {
        let durationName = serviceAssignment.durationName
        if (durationName) {
          let spaceIndex = durationName.indexOf(" Minutes")
          let minuteString = durationName.substr(0, spaceIndex);
          minutes = Number(minuteString) || 0
        }
        else {
          minutes = 0;
        }
      }
      else {
        minutes = 0;
      }
    }

    this.toTime = new Date(this.fromTime);
    this.toTime.setMinutes(this.toTime.getMinutes() + minutes);
    this.minutes = minutes;
  }

  SetFieldValues(id) {
    this.lookupProvider = null;
    this.serviceAssignment.siteId = null;
    this.duration = null;
    this.frequency == null;
    this.individualGroup = null;
    this.location = null;

    this.service = this.services.find(x => {
      //return x.starSpecialEducationServiceId === parseInt(id.value);
      return x.id === parseInt(id.value);
    })
    this.starSpecialEducationServiceId = this.service.starSpecialEducationServiceId;
    this.duration = this.service.duration.toString();
    this.frequency = this.service.frequency.toString();
    this.individualGroup = this.service.individualGroup.toString();
    this.location = this.service.location.toString();
    let oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    this.minimumStartDate = oneYearAgo;

    this.LoadServiceProviders(parseInt(this.service.starSpecialEducationServiceId));
  }

  LoadServiceProviders(starSpecialEducationServiceId) {
    this._servicesService.getMatchingServiceProviders(this._myGlobals.selectedStudent.siteId, starSpecialEducationServiceId).subscribe((res: ILookupBase[]) => {
      this.lookupProvider = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
      if (this.serviceAssignment.providerId != null) {
        var findprovider = res.find(x => {
          return x.value === this.serviceAssignment.providerId.toString()
        })
        if (findprovider == null) {
          this.lookupProvider = [{ value: this.serviceAssignment.providerId, label: this.serviceAssignment.providerName, shortText: null, updatedOn: null }];
        }
      }
    },
      err => console.error(err)
    );
  }

  LoadLookupServices() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDService]).subscribe((res: ILookupBase[]) => {
      this.lookupServiceName = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    if (this.services.length > 0) {
      var curServiceList = this.services.map(o => {
        return {
          value: o.id.toString(),
          label: `${o.starSpecialEducationServiceName} - ${o?.locationName}; ${o?.durationName}; ${o?.frequencyName}; ${o?.individualGroupName}`,
          shortText: o.starSpecialEducationServiceId.toString(),
          updatedOn: o.updatedOn,
        };
      });
      this.lookupCurrentService = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(curServiceList);;
    }

    //this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceProvider]).subscribe((res: ILookupBase[]) => {
    //  this.lookupProvider = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    //},
    //  err => console.error(err)
    //);

    if (this.serviceAssignment.starSpecialEducationServiceId != null) {
      this.LoadServiceProviders(this.serviceAssignment.starSpecialEducationServiceId);
    }

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Site]).subscribe((res: ILookupBase[]) => {
      this.lookupSites = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceDuration]).subscribe((res: ILookupBase[]) => {
      this.lookupDuration = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceFrequency]).subscribe((res: ILookupBase[]) => {
      this.lookupFrequency = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroup]).subscribe((res: ILookupBase[]) => {
      this.lookupIndividualGroup = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceLocation]).subscribe((res: ILookupBase[]) => {
      this.lookupLocation = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );
  }

  LoadLookupLog() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SessionStatus]).subscribe((res: ILookupBase[]) => {
      this.lookupSessionStatus = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AbsenceCode]).subscribe((res: ILookupBase[]) => {
      this.lookupAbsenceCode = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

  viewServicesList(): void {
    this.servicesList = true;
    this.serviceEdit = false;
    this.logList = false;
    this.logEdit = false;
  }

  scrollToBottom(): void {
    let pos = window.pageYOffset;
    //Scroll the from to position horizontally 0 and vertically 500
    if (pos < 500) {
      window.scrollTo(0, 500);
    }
  }

  cancelLog(): void {
    this.servicesList = true;
    this.serviceEdit = false;
    this.logList = true;
    this.logEdit = false;
  }

  deleteService(serviceId): void {
    //Can not delete the service assignment because it has log entries.
    this._servicesService.deleteServiceAssignment(serviceId).subscribe((res: boolean) => {
      let successMessage: Message = {
        severity: 'success', summary: 'Record Deleted Successfully',
        detail: res.toString()
      }
      //Load ServiceAssignments
      this.GetServiceAssignments()
      this.addMessage(successMessage);
    },
      err => {
        let errorMessage: Message = {
          severity: 'error', summary: 'Error: ',
          detail: err.error
        }
        this.addMessage(errorMessage)
      }
    );
  }

  convertStringToTime(timeString: string, date?: Date) {
    let timeTokens: string[] = timeString.split(':');
    if (!isNaN(Number(timeTokens[0])) && !isNaN(Number(timeTokens[1]))) {
      let hour: number = 0;
      let minute: number = 0;
      let second: number = 0;
      if (timeTokens.length >= 1) {
        hour = Number(timeTokens[0]);
      }
      if (timeTokens.length >= 2) {
        minute = Number(timeTokens[1]);
      }
      if (timeTokens.length >= 3) {
        second = Number(timeTokens[2]);
      }

      if (date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute, second)
      }
      else {
        date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute, second)
      }
      
    }
    return null;
  }

  onEndDateFocus() {
    if (this.toTime === null || this.toTime === undefined) {
      this.toTime = new Date(this.fromTime);
    }
  }

  calculateEndDate(startTime: Date, minutes: number): Date {
    //use minutes to calculate endtime on save
    let endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + minutes);

    return endTime;
  }

  calculateMinutes(startTime: Date, endTime: Date): number {
    if (!startTime || !endTime) {
      return 0;
    }

    let timeDif = startTime.getTime() - endTime.getTime();
    let minutes = timeDif / 1000 / 60;

    return minutes
  }

  calculateMinutesFromString(startTimeString: string, endTimeString: string): number {
    if (!startTimeString || !endTimeString) {
      return 0;
    }
    let startTime = this.convertStringToTime(startTimeString);
    let endTime = this.convertStringToTime(endTimeString);
    
    let timeDif = endTime.getTime() - startTime.getTime();
    let minutes = timeDif / 1000 / 60;

    return minutes
  }
}
